import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem7IT = () => {
  const data = [
    {
      subjectName: "2021 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1tNiNidZhLaLlB4Agk-GIp1MecEuBnGds/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2022 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/16irho8jctG_mNpxlI3vMggBDpMag_aPM/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">IT Sem - 7</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem7IT